


























import Vue from 'vue'
import Component from 'vue-class-component'
import { IResident, EResidentStatus } from '@zunta/configurations'

@Component({
  props: {
    resident: {
      type: Object,
      required: true
    },
    statusCircle: {
      type: Boolean,
      default: false
    },
    wide: {
      type: Boolean,
      default: false
    },
  }
})
export default class ResidentLabel extends Vue {
  resident: IResident = this.$props.resident;
  EResidentStatus = EResidentStatus;
  getResidentStatusLabel (status: EResidentStatus): string {
    return ({
      [EResidentStatus.ACTIVE]: 'Current',
      [EResidentStatus.INACTIVE]: 'Discharged'
    } as Record<EResidentStatus, string>)[status]
  }
  getOriginId () {
    return this.resident.ncsResidentId || this.resident.originid
  }
}
